import React, { useState, useCallback, useMemo } from 'react';
import { Typography, Scrollbar } from '@ann/web-components';
import {
  HistoryPanelContainer,
  HistoryList,
  HistoryGroup,
  HistoryGroupTitle,
  HistoryItem,
  HistoryItemText,
} from './HistoryPanel.styled';

const HistoryPanel = ({ contactId }) => {
  // TODO: Reemplazar con datos reales del backend
  const [conversations] = useState([
    {
      id: 1,
      title: 'Appointment scheduling and follow-up',
      date: new Date(),
      group: 'Today',
    },
    {
      id: 2,
      title: 'Sales conversation – needs follow-up info',
      date: new Date(Date.now() - 86400000), // Yesterday
      group: 'Yesterday',
    },
    {
      id: 3,
      title: 'Potential buyer – follow-up required',
      date: new Date(Date.now() - 2 * 86400000),
      group: 'Last 7 days',
    },
    {
      id: 4,
      title: 'Customer inquiry about test drive',
      date: new Date(Date.now() - 3 * 86400000),
      group: 'Last 7 days',
    },
    {
      id: 5,
      title: 'Customer still deciding — follow up soon',
      date: new Date(Date.now() - 4 * 86400000),
      group: 'Last 7 days',
    },
    {
      id: 6,
      title: 'Initial contact + test drive booked',
      date: new Date(Date.now() - 5 * 86400000),
      group: 'Last 7 days',
    },
    {
      id: 7,
      title: 'Potential buyer – follow-up required',
      date: new Date(Date.now() - 10 * 86400000),
      group: 'Last 30 days',
    },
    {
      id: 8,
      title: 'Customer inquiry about test drive',
      date: new Date(Date.now() - 15 * 86400000),
      group: 'Last 30 days',
    },
    {
      id: 9,
      title: 'Customer still deciding — follow up soon',
      date: new Date(Date.now() - 20 * 86400000),
      group: 'Last 30 days',
    },
    {
      id: 10,
      title: 'Initial contact + test drive booked',
      date: new Date(Date.now() - 25 * 86400000),
      group: 'Last 30 days',
    },
    {
      id: 11,
      title: 'Potential buyer – follow-up required',
      date: new Date(Date.now() - 60 * 86400000),
      group: 'Last 3 months',
    },
    {
      id: 12,
      title: 'Customer inquiry about test drive',
      date: new Date(Date.now() - 70 * 86400000),
      group: 'Last 3 months',
    },
    {
      id: 13,
      title: 'Customer still deciding — follow up soon',
      date: new Date(Date.now() - 80 * 86400000),
      group: 'Last 3 months',
    },
    {
      id: 14,
      title: 'Initial contact + test drive booked',
      date: new Date(Date.now() - 90 * 86400000),
      group: 'Last 3 months',
    },
  ]);

  const groupedConversations = useMemo(() => {
    const groups = {
      'Today': [],
      'Yesterday': [],
      'Last 7 days': [],
      'Last 30 days': [],
      'Last 3 months': [],
    };

    conversations.forEach((conversation) => {
      if (groups[conversation.group]) {
        groups[conversation.group].push(conversation);
      }
    });

    return groups;
  }, [conversations]);

  const handleItemClick = useCallback((conversation) => {
    // TODO: Implementar lógica para cargar la conversación seleccionada
    console.log('Selected conversation:', conversation);
  }, []);

  const groupOrder = ['Today', 'Yesterday', 'Last 7 days', 'Last 30 days', 'Last 3 months'];

  return (
    <HistoryPanelContainer>
      <Scrollbar size="small">
        <HistoryList>
          {groupOrder.map((groupName) => {
            const groupItems = groupedConversations[groupName];
            if (!groupItems || groupItems.length === 0) return null;

            return (
              <HistoryGroup key={groupName}>
                <HistoryGroupTitle>
                  <Typography category="subtitle" weight="bold" size="small" color="subtitle">
                    {groupName}
                  </Typography>
                </HistoryGroupTitle>
                {groupItems.map((item) => (
                  <HistoryItem
                    key={item.id}
                    onClick={() => handleItemClick(item)}
                  >
                    <HistoryItemText>
                      <Typography category="body" weight="regular" size="medium" color="body">
                        {item.title}
                      </Typography>
                    </HistoryItemText>
                  </HistoryItem>
                ))}
              </HistoryGroup>
            );
          })}
        </HistoryList>
      </Scrollbar>
    </HistoryPanelContainer>
  );
};

export default HistoryPanel;

